import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";
import { useLang } from "../i18n";

export default function PaymentCancel() {
  const { t } = useLang();
  return (
    <main data-testid="payment-cancel-page" className="min-h-screen flex items-center justify-center px-6 py-32">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-lg w-full border border-line/70 bg-sand p-10 md:p-14 text-center"
      >
        <XCircle className="w-12 h-12 text-clay mx-auto mb-6" strokeWidth={1.5} />
        <h1 className="font-serif text-3xl md:text-4xl tracking-tight mb-4">{t("payment.cancelTitle")}</h1>
        <p className="text-ink/60 text-sm leading-relaxed mb-8">{t("payment.cancelSub")}</p>
        <Link to="/" data-testid="cancel-try-again" className="inline-flex px-8 py-4 bg-terra text-sand text-xs font-bold tracking-[0.2em] uppercase hover:bg-clay transition-colors">
          {t("payment.tryAgain")}
        </Link>
      </motion.div>
    </main>
  );
}
